import { Component, Host } from '@angular/core';
import { MultiControllerComponent } from '../../multi-controller.component';

@Component({
    selector: 'ms-multi-screen-play',
    templateUrl: './multi-screen-play.component.html',
    styleUrls: ['./multi-screen-play.component.scss'],
    standalone: false
})
export class MultiScreenPlayComponent {
  constructor(@Host() public readonly multiController: MultiControllerComponent) {}
}
